import React, { Component } from "react";

class Header extends Component {
  render() {
    return (
      <header className="fixed top-0 left-0 w-full bg-white text-gray-800 shadow-lg z-10">
        <div className="container mx-auto flex items-center p-4">
          <img
            src="https://internal.letsflo.io/assets/images/logo-light.png"
            alt="LetsFlo Logo"
            className="h-10"
          />
          <h1 className="text-xl font-bold">API Auto Test</h1>
        </div>
      </header>
    );
  }
}

export default Header;
